import { useUser } from "@ip-contexts/user-context";

import routes, { Route, SubRoute } from "../Routes";

export default function usePermission() {
  const {
    state: { user },
  } = useUser();

  const userHasAllRequiredPermission = (route: Route | SubRoute) => {
    for (const audience in route.roles) {
      const res = route.roles[audience]?.every((scope: string) => {
        return user.roles[audience]?.includes(scope);
      });

      if (!res) {
        return false;
      }
    }
    return true;
  };

  const hasSufficientPermission = (route: Route | SubRoute, path: string) => {
    if (route.path === path && route.roles) {
      const hasSufficientPermission = userHasAllRequiredPermission(route);
      if (hasSufficientPermission) {
        return true;
      }
    } else if (route.path === path) {
      if (!route.roles) {
        return true;
      }
    }
  };

  const hasPermission = (path: string) => {
    for (const route of routes) {
      const res = hasSufficientPermission(route, path);
      if (res) {
        return true;
      }

      if (route.subRoutes) {
        for (const subRoute of route.subRoutes) {
          const res = hasSufficientPermission(subRoute, path);
          if (res) {
            return true;
          }
        }
      }
    }
    return false;
  };

  return { hasPermission };
}
